import React, { useState } from "react";
import { api_url } from "../../utils/Enviroment";
import axios from 'axios';
import { toast } from "react-toastify";
import { useWeb3React } from '@web3-react/core';

const LikeButton = ({ itemId, isLiked, setLikeData }) => {
    const [isActive, setIsActive] = useState(isLiked);
    const [isHovered, setIsHovered] = useState(false);
    const { account } = useWeb3React();

    const handleButtonClick = async (event) => {
        const token = localStorage?.getItem("accessToken");
        if (!token) {
            toast?.error("Please Connect wallet first")
            return
        }
        setIsActive(!isActive);
        event.stopPropagation();
        event.preventDefault();
        const payload = {
            commentId: itemId,
            walletAddress: account,
        };
        try {
            const response = await axios.patch(`${api_url}comment/toggle-like-comment`, payload, { headers: { "Authorization": `Bearer ${token}` } });
            setLikeData(response?.data?.data)
        } catch (error) {
            console.error("Error: ", error);
        }
    };
    const styles = {
        hover: {
            // width: '150px',
        },
    };


    return (
        <button
            className="wishlistbtn"
            onClick={handleButtonClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                ...(isHovered && isActive ? styles.hover : {}),
                border: 'none',
                background: 'none',
            }}
        >
            {isActive ?
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 2.94006L7 5.00006H9.915C10.0702 5.00006 10.2234 5.03621 10.3622 5.10563C10.5011 5.17506 10.6219 5.27587 10.715 5.40006C10.8081 5.52426 10.8711 5.66843 10.8989 5.82118C10.9266 5.97392 10.9185 6.13103 10.875 6.28006L9.71 10.2801C9.64942 10.4878 9.5231 10.6702 9.35 10.8001C9.1769 10.9299 8.96637 11.0001 8.75 11.0001H2C1.73478 11.0001 1.48043 10.8947 1.29289 10.7072C1.10536 10.5196 1 10.2653 1 10.0001V6.00006C1 5.73484 1.10536 5.48049 1.29289 5.29295C1.48043 5.10542 1.73478 5.00006 2 5.00006H3.38C3.56604 4.99996 3.74837 4.94797 3.90648 4.84992C4.06459 4.75188 4.19221 4.61167 4.275 4.44506L6 1.00006C6.23579 1.00298 6.46787 1.05915 6.6789 1.16436C6.88994 1.26957 7.07446 1.42111 7.2187 1.60766C7.36294 1.79421 7.46316 2.01094 7.51187 2.24166C7.56058 2.47238 7.55652 2.71113 7.5 2.94006Z" fill="#000000" stroke="#000000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                :
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_658_866)">
                        <path d="M3.5 5.00006V11.0001" stroke="#000000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.5 2.94006L7 5.00006H9.915C10.0702 5.00006 10.2234 5.03621 10.3622 5.10563C10.5011 5.17506 10.6219 5.27587 10.715 5.40006C10.8081 5.52426 10.8711 5.66843 10.8989 5.82118C10.9266 5.97392 10.9185 6.13103 10.875 6.28006L9.71 10.2801C9.64942 10.4878 9.5231 10.6702 9.35 10.8001C9.1769 10.9299 8.96637 11.0001 8.75 11.0001H2C1.73478 11.0001 1.48043 10.8947 1.29289 10.7072C1.10536 10.5196 1 10.2653 1 10.0001V6.00006C1 5.73484 1.10536 5.48049 1.29289 5.29295C1.48043 5.10542 1.73478 5.00006 2 5.00006H3.38C3.56604 4.99996 3.74837 4.94797 3.90648 4.84992C4.06459 4.75188 4.19221 4.61167 4.275 4.44506L6 1.00006C6.23579 1.00298 6.46787 1.05915 6.6789 1.16436C6.88994 1.26957 7.07446 1.42111 7.2187 1.60766C7.36294 1.79421 7.46316 2.01094 7.51187 2.24166C7.56058 2.47238 7.55652 2.71113 7.5 2.94006Z" stroke="#000000" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_658_866">
                            <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                </svg>


            }
        </button>
    );
};

export default LikeButton;

